/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _isSuspectedBot = __webpack_require__(2);
	
	var _isSuspectedBot2 = _interopRequireDefault(_isSuspectedBot);
	
	__webpack_require__(3);
	
	var _PackagesUtil = __webpack_require__(4);
	
	var _PackagesUtil2 = _interopRequireDefault(_PackagesUtil);
	
	var _convertSiteModel2 = __webpack_require__(5);
	
	var _convertSiteModel3 = _interopRequireDefault(_convertSiteModel2);
	
	var _render2 = __webpack_require__(6);
	
	var _render3 = _interopRequireDefault(_render2);
	
	var _addExperimentsFromQuery = __webpack_require__(9);
	
	var _addExperimentsFromQuery2 = _interopRequireDefault(_addExperimentsFromQuery);
	
	var _applyPackagesCache = __webpack_require__(10);
	
	var _applyPackagesCache2 = _interopRequireDefault(_applyPackagesCache);
	
	var _getFullRjsConfig = __webpack_require__(11);
	
	var _getFullRjsConfig2 = _interopRequireDefault(_getFullRjsConfig);
	
	var _getQueryUtils = __webpack_require__(13);
	
	var _getQueryUtils2 = _interopRequireDefault(_getQueryUtils);
	
	var _getSubdomain = __webpack_require__(14);
	
	var _getSubdomain2 = _interopRequireDefault(_getSubdomain);
	
	var _instruments2 = __webpack_require__(15);
	
	var _instruments3 = _interopRequireDefault(_instruments2);
	
	var _joinURL = __webpack_require__(12);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);
	
	var _mobile = __webpack_require__(16);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _overrideScriptsLocationMapFromQuery = __webpack_require__(17);
	
	var _overrideScriptsLocationMapFromQuery2 = _interopRequireDefault(_overrideScriptsLocationMapFromQuery);
	
	var _requirejs = __webpack_require__(19);
	
	var _requirejs2 = _interopRequireDefault(_requirejs);
	
	var _resourcePrefetch = __webpack_require__(20);
	
	var _resourcePrefetch2 = _interopRequireDefault(_resourcePrefetch);
	
	var _rjsConfig = __webpack_require__(21);
	
	var _rjsConfig2 = _interopRequireDefault(_rjsConfig);
	
	var _storageUtil = __webpack_require__(22);
	
	var _storageUtil2 = _interopRequireDefault(_storageUtil);
	
	var _utils = __webpack_require__(23);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This should be before the Polyfill
	var options = __webpack_require__(24); // eslint-disable-line sort-imports
	
	/* global window */
	/* eslint prefer-template:0 */
	
	window.persistent = (0, _storageUtil2.default)(window); // TODO: how is this used?
	var queryUtil = (0, _getQueryUtils2.default)(window);
	window.queryUtil = queryUtil;
	
	// Preload scripts for caching
	var prefetch = window.isPrefetchMode || window.location.pathname.indexOf('prefetch') > 0 || queryUtil.isParameterTrue('prefetch');
	
	var rendererModel = window.rendererModel;
	var render = (0, _render3.default)(window, _requirejs2.default, prefetch);
	var packagesUtil = new _PackagesUtil2.default(options.packages, window.location.search);
	var getViewerRjsConfig = (0, _rjsConfig2.default)(window, options.versions);
	
	var _instruments = (0, _instruments3.default)(window, _requirejs2.default, _isSuspectedBot2.default, prefetch),
	    sendErrorOrQueue = _instruments.sendErrorOrQueue,
	    instrument = _instruments.instrument;
	
	var convertSiteModel = (0, _convertSiteModel3.default)(window, sendErrorOrQueue);
	var isPreview = queryUtil.isParameterTrue('isEdited');
	var isServerSide = !(window.clientSideRender || window.location.hash || isPreview);
	
	var wixBiSession = window.wixBiSession || {};
	window.wixBiSession = wixBiSession;
	wixBiSession.mainLoaded = Date.now();
	wixBiSession.et = 1;
	
	var publicModel = window.publicModel;
	var serviceTopology = window.serviceTopology || {};
	serviceTopology.scriptsLocationMap = (0, _overrideScriptsLocationMapFromQuery2.default)(serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'));
	
	rendererModel.runningExperiments = (0, _addExperimentsFromQuery2.default)(rendererModel.runningExperiments, queryUtil, 'viewer');
	var isOpen = _utils2.default.initExperimentTest(rendererModel.runningExperiments);
	
	window.siteModel = convertSiteModel(rendererModel, publicModel);
	var siteModel = window.siteModel;
	
	var pageInfo = publicModel && _utils2.default.getPageInfo(window, publicModel.pageList);
	
	instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo);
	
	var contentCache = function contentCache() {}; //eslint-disable-line func-style
	var dynamicModel = null;
	if (publicModel && !queryUtil.isParameterTrue('prefetch')) {
	  var resourcePrefetchOptions = {
	    siteModel: siteModel,
	    publicModel: publicModel,
	    pageInfo: pageInfo,
	    shouldTimeout: isOpen('pageRequestTimeout'),
	    wixBiSession: wixBiSession,
	    dynamicModel: dynamicModel,
	    isServerSide: isServerSide
	  };
	  contentCache = (0, _resourcePrefetch2.default)(window, resourcePrefetchOptions);
	}
	
	if (window.karmaIntegration) {
	  siteModel.documentServicesModel = siteModel.documentServicesModel || window.karmaIntegration.documentServicesModel;
	  siteModel.wixapps = siteModel.wixapps || {};
	  siteModel.wixapps.appbuilder = siteModel.wixapps.appbuilder || {};
	  siteModel.wixapps.appbuilder.descriptor = siteModel.wixapps.appbuilder.descriptor || {};
	  siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion = siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion || {};
	}
	
	var config = (0, _getFullRjsConfig2.default)('santa', window.santaBase, getViewerRjsConfig(serviceTopology), packagesUtil, serviceTopology);
	
	if (rendererModel.runningExperiments.packagescache === 'new') {
	  if (!options.disablePackagesCache) {
	    (0, _applyPackagesCache2.default)({
	      proj: 'santa',
	      paths: config.paths,
	      manifest: options.manifest,
	      version: options.version,
	      scriptsDomainUrl: window.serviceTopology.scriptsDomainUrl
	    });
	  }
	}
	
	siteModel.santaBase = config.baseUrl;
	serviceTopology.staticServerFallbackUrl = serviceTopology.staticServerFallbackUrl || 'https://fallback.wix.com/';
	var semverMatches = siteModel.santaBase.match(/\/(\d+\.\d+\.\d+)\/?$/);
	siteModel.baseVersion = semverMatches && semverMatches[1];
	siteModel.santaBaseFallbackUrl = siteModel.baseVersion ? (0, _joinURL2.default)(serviceTopology.staticServerFallbackUrl, siteModel.baseVersion) : null;
	
	_requirejs2.default.config(config);
	
	try {
	  window.document.domain = (0, _getSubdomain2.default)(window.document.domain);
	} catch (e) {
	  // empty
	}
	
	window.isPreview = queryUtil.isParameterTrue.bind(null, 'isEdited');
	var isExternalPreview = rendererModel.previewMode;
	var mobileView = _mobile2.default.isMobileView(window, siteModel, queryUtil);
	
	render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, dynamicModel, config);
	wixBiSession.beat(4);

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !Function.prototype.bind;

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	if (!Function.prototype.bind) {
	  Function.prototype.bind = function (object) {
	    //eslint-disable-line no-extend-native
	    var self = this;
	    var slice = Array.prototype.slice;
	    var args = slice.call(arguments, 1);
	    return function () {
	      return self.apply(object, args.concat(slice.call(arguments)));
	    };
	  };
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint prefer-template:0 */
	
	function PackagesUtil(packagesStructure, query) {
	  /**
	   * @param {string} str
	   * @param {string} separator
	   * @param {string} equalizer
	   * @return {Object.<String, String>}
	   */
	  function reduceStringToObject(str, separator, equalizer) {
	    return (str || '').split(separator).reduce(function (o, pairString) {
	      var pair = pairString.split(equalizer);
	      o[pair[0]] = pair[1];
	      return o;
	    }, {});
	  }
	
	  var queryParamsObject = reduceStringToObject(query.replace(/^\?/, ''), '&', '=');
	
	  /**
	   * changes the confiIg to load packages correctly, accounting the query
	   * @param {Object} config
	   * @returns {Object}
	   */
	  this.buildConfig = function (config) {
	    var debug = (queryParamsObject.debug || '').split(',').filter(Boolean);
	    if (debug.indexOf('all') !== -1) {
	      var debuggableExternals = Object.keys(config.paths).filter(function (path) {
	        return config.paths[path].source;
	      });
	      debug = packagesStructure.concat(debuggableExternals);
	    }
	
	    function isInDebug(i) {
	      return debug.indexOf(i) !== -1;
	    }
	
	    //config.paths:
	    Object.keys(config.paths).filter(function (k) {
	      return _typeof(config.paths[k]) === 'object' && !Array.isArray(config.paths[k]);
	    }).forEach(function (k) {
	      config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min'];
	    });
	
	    //config.bundles:
	    config.bundles = config.bundles || {};
	    packagesStructure.filter(function (pkg) {
	      return !isInDebug(pkg);
	    }).forEach(function (pkg) {
	      config.bundles[pkg] = pkg;
	      config.paths[pkg] = 'packages-bin/' + pkg + '/' + pkg + '.min';
	    });
	
	    //config.packages:
	    config.packages = config.packages || [];
	    var projectPackages = packagesStructure.filter(isInDebug).map(function (name) {
	      return {
	        name: name,
	        location: 'packages/' + name + '/src/main',
	        main: name
	      };
	    });
	    config.packages = config.packages.concat(projectPackages);
	
	    return config;
	  };
	}
	
	exports.default = PackagesUtil;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window, sendErrorOrQueue) {
	  return function convertSiteModel(rendererModel, publicModel) {
	    function getPagesDataFromSiteAsJson(siteJson) {
	      var initialPagesData = {
	        masterPage: siteJson.masterPage
	      };
	
	      return siteJson.pages.reduce(function (accum, val) {
	        accum[val.structure.id] = val;
	        return accum;
	      }, initialPagesData);
	    }
	
	    var siteModel = {
	      publicModel: publicModel,
	      urlFormatModel: rendererModel.urlFormatModel,
	      routers: rendererModel.routers,
	      serviceTopology: window.serviceTopology,
	      santaBase: window.santaBase,
	      configUrls: window.configUrls,
	      rendererModel: rendererModel,
	      componentGlobals: window.componentGlobals,
	      serverAndClientRender: window.serverAndClientRender,
	      adData: window.adData,
	      mobileAdData: window.mobileAdData,
	      googleAnalytics: window.googleAnalytics,
	      googleRemarketing: window.googleRemarketing,
	      facebookRemarketing: window.facebookRemarketing,
	      yandexMetrika: window.yandexMetrika,
	      wixData: window.wixData,
	      wixapps: window.wixapps || getDefaultWixappsModel(),
	      wixBiSession: window.wixBiSession,
	      pagesData: window.pagesData || window.warmupData && window.warmupData.fullPagesData,
	      svgShapes: window.svgShapes,
	      contactforms_metadata: {},
	      renderFlags: {}
	    };
	    siteModel.siteHeader = { id: siteModel.rendererModel.siteId, userId: siteModel.rendererModel.userId }; // required
	    siteModel.siteId = siteModel.rendererModel.siteId; // required
	    siteModel.viewMode = siteModel.rendererModel.previewMode ? 'preview' : 'site'; // required
	    if (window.siteAsJson) {
	      movePageDataToMaster(window.siteAsJson, sendErrorOrQueue);
	      siteModel.pagesData = getPagesDataFromSiteAsJson(window.siteAsJson);
	    }
	    var pagesPlatformApplications = getPagesPlatformApplications(siteModel);
	    if (pagesPlatformApplications) {
	      siteModel.pagesPlatformApplications = pagesPlatformApplications;
	    }
	    if (window.documentServicesModel) {
	      siteModel.documentServicesModel = window.documentServicesModel;
	    }
	    if (window.warmupData && window.warmupData.wixapps) {
	      siteModel.wixapps = window.warmupData.wixapps;
	    }
	    return siteModel;
	  };
	};
	
	function getDefaultWixappsModel() {
	  return { appbuilder: { metadata: { appbuilder_metadata: { requestedPartNames: [] } } } };
	}
	
	function getWixCodeAppDefId(clientSpecMap) {
	  for (var spec in clientSpecMap) {
	    if (clientSpecMap[spec].type === 'siteextension') {
	      return clientSpecMap[spec].appDefinitionId.toString();
	    }
	  }
	}
	
	function isGuid(appId) {
	  var guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
	  return guidRegex.test(appId);
	}
	
	function getPagesPlatformApplications(siteModel) {
	  var wixCodeAppDefId = getWixCodeAppDefId(siteModel.rendererModel.clientSpecMap);
	  if (!wixCodeAppDefId) {
	    return;
	  }
	  var pagesPlatformApplications = siteModel.rendererModel.pagesPlatformApplications;
	  var result = {};
	
	  var _loop = function _loop(pageId) {
	    if (pagesPlatformApplications.hasOwnProperty(pageId)) {
	      pagesPlatformApplications[pageId].forEach(function (appId) {
	        if (isGuid(appId)) {
	          appId = 'wixCode';
	        }
	        result[appId] = result[appId] || {};
	        result[appId][pageId] = true;
	      });
	    }
	  };
	
	  for (var pageId in pagesPlatformApplications) {
	    _loop(pageId);
	  }
	  return result;
	}
	
	function movePageDataToMaster(siteAsJson, sendErrorOrQueue) {
	  var masterData = siteAsJson.masterPage.data.document_data;
	
	  function move(ref, to, from) {
	    if (!get(from, ref)) {
	      return;
	    }
	
	    if (!get(to, ref)) {
	      set(to, ref, get(from, ref));
	    }
	    remove(from, ref);
	  }
	
	  function get(parentData, ref) {
	    return ref && parentData[ref.replace('#', '')];
	  }
	
	  function set(parentData, ref, dataToSet) {
	    if (ref) {
	      parentData[ref.replace('#', '')] = dataToSet;
	    }
	  }
	
	  function remove(parentData, ref) {
	    if (ref) {
	      delete parentData[ref.replace('#', '')];
	    }
	  }
	
	  function moveMediaRef(masterPageDocumentData, pageData, mediaRef) {
	    // Image or WixVideo
	    var media = get(pageData, mediaRef);
	    move(mediaRef, masterPageDocumentData, pageData);
	    // Image
	    move(media.posterImageRef, masterPageDocumentData, pageData);
	  }
	
	  siteAsJson.pages.forEach(function (page) {
	    if (!page.structure) {
	      return;
	    }
	
	    var pageData = page.data.document_data;
	    var pageId = page.structure.id;
	    var desktopBg = void 0;
	    var mobileBg = void 0;
	
	    // Pages or AppPages
	    var pageItem = get(pageData, pageId);
	    move(pageId, masterData, pageData);
	
	    if (pageItem && pageItem.pageBackgrounds && pageItem.pageBackgrounds.desktop.ref) {
	      // BackgroundImage or BackgroundMedia
	      desktopBg = get(pageData, pageItem.pageBackgrounds.desktop.ref);
	      mobileBg = get(pageData, pageItem.pageBackgrounds.mobile.ref);
	      move(pageItem.pageBackgrounds.desktop.ref, masterData, pageData);
	      move(pageItem.pageBackgrounds.mobile.ref, masterData, pageData);
	
	      // const wixBiSession = window.wixBiSession || {} TODO: Indeed unused?
	
	      //BackgroundMedia
	      if (desktopBg) {
	        if (desktopBg.mediaRef) {
	          moveMediaRef(masterData, pageData, desktopBg.mediaRef);
	        }
	        //Image
	        move(desktopBg.imageOverlay, masterData, pageData);
	      } else {
	        sendErrorOrQueue({
	          errorName: 'MISSING_DESKTOP_BACKGROUND_ITEM',
	          errorCode: 112001,
	          severity: 30
	        }, pageItem.id);
	      }
	
	      if (mobileBg) {
	        if (mobileBg.mediaRef) {
	          moveMediaRef(masterData, pageData, mobileBg.mediaRef);
	        }
	        //Image
	        move(mobileBg.imageOverlay, masterData, pageData);
	      } else {
	        sendErrorOrQueue({
	          errorName: 'MISSING_MOBILE_BACKGROUND_ITEM',
	          errorCode: 112002,
	          severity: 30
	        }, pageItem.id);
	      }
	    }
	  });
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window, requirejs, prefetch) {
	  if (prefetch && window.define) {
	    var dummy = function dummy() {
	      return {};
	    };
	    var define = window.define;
	    window.define = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      for (var i = 0; i < args.length; ++i) {
	        if (typeof args[i] === 'function') {
	          args[i] = dummy;
	        }
	      }
	      return define.apply(this, args);
	    };
	    window.define.amd = define.amd;
	    var rjs = requirejs;
	    window.requirejs = requirejs = function requirejs(dependencies) {
	      return rjs.call(this, dependencies, dummy);
	    };
	  }
	
	  function render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, dynamicModelUrl, config) {
	    function addConditionalDependencies(pkgs) {
	      function shouldLoadPackageFor(applicationType) {
	        var map = siteModel.rendererModel.clientSpecMap;
	        return Object.keys(map).some(function (applicationId) {
	          return map[applicationId].type === applicationType;
	        });
	      }
	
	      var isQaAutomation = queryUtil.isParameterTrue.bind(queryUtil, 'isqa');
	      var isTpaIntegration = queryUtil.isParameterTrue.bind(queryUtil, 'isTpaIntegration');
	      var isWixCodeIntegration = queryUtil.isParameterTrue.bind(queryUtil, 'isWixCodeIntegration');
	
	      function insert(p, marker) {
	        var extra = Array.prototype.slice.call(arguments, 2);
	        var pos = p.indexOf(marker);
	        if (pos !== -1) {
	          pkgs.splice.apply(p, [pos, 0].concat(extra));
	        } else {
	          pkgs.push.apply(p, extra);
	        }
	      }
	
	      function isWixDomain() {
	        return window.location.hostname === 'www.wix.com';
	      }
	
	      function isWixSites() {
	        return isWixDomain() || queryUtil.isParameterTrue('iswixsite');
	      }
	
	      function isWixCloud() {
	        return shouldLoadPackageFor('siteextension');
	      }
	
	      function shouldLoadPackageForEComMigratedSite() {
	        return areMetaSiteFlagsExist() && siteModel.publicModel.metaSiteFlags.indexOf('EComMigrated') >= 0;
	      }
	
	      function areMetaSiteFlagsExist() {
	        return siteModel.publicModel && siteModel.publicModel.metaSiteFlags;
	      }
	
	      if (isPreview || shouldLoadPackageFor('wixapps') || shouldLoadPackageFor('ecommerce') || shouldLoadPackageForEComMigratedSite()) {
	        insert(pkgs, 'tpa', 'wixappsCore', 'wixappsClassics');
	      }
	      if (isPreview || shouldLoadPackageFor('appbuilder')) {
	        insert(pkgs, 'tpa', 'wixappsCore', 'wixappsBuilder');
	      }
	      if (queryUtil.isParameterTrue('ds') || isPreview || isExternalPreview) {
	        pkgs.push('componentsPreviewLayer');
	      }
	      if (queryUtil.isParameterTrue('ds') || isPreview) {
	        pkgs.push('documentServices');
	      }
	      if (isPreview) {
	        pkgs.push('immutable');
	      }
	      if (isQaAutomation()) {
	        pkgs.push('qaAutomation', 'react');
	      }
	      if (isWixSites()) {
	        pkgs.push('wixSites');
	      }
	      if (isTpaIntegration()) {
	        pkgs.push('tpaIntegration', 'jasmine', 'jasmine-html');
	      }
	      if (isWixCodeIntegration()) {
	        pkgs.push('wixCodeIntegration', 'jasmine', 'jasmine-html');
	      }
	      if (isWixCloud() || isPreview) {
	        pkgs.push('wixCode');
	      }
	
	      return pkgs;
	    }
	
	    var handleRequireError = prefetch ? function () {} : function (pkgs) {
	      return function (err) {
	        if (!config.urlArgs) {
	          if (err.requireModules) {
	            err.requireModules.forEach(function (module) {
	              requirejs.undef(module);
	            });
	          }
	          config.urlArgs = 'c=' + Date.now();
	          requirejs.config(config);
	          var errClone = Object.keys(err).reduce(function (r, k) {
	            r[k] = err[k];
	            return r;
	          }, {});
	          errClone.message = err.message;
	          errClone.stack = err.stack ? '' + err.stack : '';
	          requirejs(pkgs, function () {
	            errClone.errn = 'REQUIREJS_RETRY_ERROR';
	            errClone.errc = 111025;
	            errClone.severity = 10;
	            requirejs.onError(errClone);
	          }, requirejs.onError);
	        }
	      };
	    };
	
	    function loadAdditional(pkgs) {
	      requirejs(pkgs, function () {
	        var p = buildFunctionParametersObject(pkgs, arguments);
	
	        function buildFunctionParametersObject(_pkgs, args) {
	          return _pkgs.reduce(function (result, pkg, index) {
	            result[pkg] = args[index];
	            return result;
	          }, {});
	        }
	
	        function initConditionalDependencies(_pkgs) {
	          if (_pkgs.qaAutomation) {
	            _pkgs.qaAutomation.init(window, siteModel);
	          }
	          if (_pkgs.tpaIntegration) {
	            _pkgs.tpaIntegration.init(window, p.core);
	          }
	          if (_pkgs.wixCodeIntegration) {
	            _pkgs.wixCodeIntegration.init(window, p.core, p.wixCode, p.widgets, p.utils);
	          }
	        }
	
	        initConditionalDependencies(p);
	      }, handleRequireError(pkgs));
	    }
	
	    function load(pkgs, callback) {
	      /*
	       * Require all needed packages (static + conditional)
	       * Then do initial site render (or re-layout if it was rendered by the server)
	       */
	      function getAjaxHandler($) {
	        var ignore = {};
	
	        var isXhrWithCredentials = function () {
	          try {
	            var xhr = new window.XMLHttpRequest();
	            return 'withCredentials' in xhr;
	          } catch (e) {
	            return false;
	          }
	        }();
	
	        function setCallbacks(xhr, options) {
	          xhr.onerror = function (e) {
	            //eslint-disable-line no-unused-vars
	            if (options.error) {
	              options.error(xhr);
	            }
	          };
	          xhr.onload = function () {
	            if (this.status >= 200 && this.status < 300) {
	              if (options.success) {
	                var response = null;
	                try {
	                  response = JSON.parse(xhr.responseText);
	                } catch (e) {
	                  response = xhr.responseText;
	                }
	                options.success(response);
	              }
	            } else {
	              this.onerror();
	            }
	          };
	        }
	
	        function canUseCache(options) {
	          return !ignore[options.url] && (!options.type || options.type.toUpperCase() === 'GET');
	        }
	
	        function error(msg) {
	          try {
	            console.error(msg);
	          } catch (e) {
	            // empty
	          }
	        }
	
	        return function ajax(options) {
	          if (options.cache !== false && canUseCache(options) && contentCache(options)) {
	            return;
	          }
	          ignore[options.url] = true;
	
	          if (isXhrWithCredentials) {
	            $.ajax.apply($, arguments);
	          } else if (typeof XDomainRequest !== 'undefined') {
	            /*globals XDomainRequest:true*/
	            var xhr = new XDomainRequest();
	            var httpMethod = options.type || 'GET';
	            xhr.open(httpMethod, options.url);
	            setCallbacks(xhr, options);
	            xhr.setRequestHeader = function () {}; // ignores request headers in IE (not supported)
	            xhr.send();
	          } else {
	            error('XHR cors not supported, and neither is XDR');
	          }
	        };
	      }
	
	      requirejs(pkgs, function () {
	        wixBiSession.packagesLoaded = Date.now();
	
	        function buildFunctionParametersObject(_pkgs, args) {
	          return _pkgs.reduce(function (result, pkg, index) {
	            result[pkg] = args[index];
	            return result;
	          }, {});
	        }
	
	        var p = buildFunctionParametersObject(pkgs, arguments);
	        var ajaxHandler = getAjaxHandler(p.zepto);
	        p.coreUtils.ajaxLibrary.register(ajaxHandler);
	
	        if (siteModel.wixData) {
	          var siteStructureNode = window.document.getElementById('masterPage') || window.document.getElementById('SITE_STRUCTURE');
	          siteModel.wixHtmlRaw = siteStructureNode.outerHTML;
	          siteModel.wixAnchors = window.anchors || {};
	          siteStructureNode.parentNode.removeChild(siteStructureNode);
	        }
	
	        siteModel.requestModel = {
	          userAgent: window.navigator.userAgent,
	          cookie: window.document.cookie,
	          storage: p.coreUtils.storage(window)
	        };
	        siteModel.currentUrl = p.coreUtils.urlUtils.parseUrl(window.serverSideUrl || window.location.href);
	        siteModel.forceMobileView = window.forceMobileView;
	
	        callback(p, ajaxHandler);
	      }, handleRequireError(pkgs));
	    }
	
	    function getClientSidePackages() {
	      var clientSidePackages = ['lodash', 'coreUtils', 'skins', 'components', 'core', 'mobx', 'mobx-react', 'color', 'zepto', 'TimelineMax', 'animations', 'react', 'layout', 'tpa', 'dataFixer', 'siteUtils', 'translationsUtils', 'hammer', 'utils', 'fonts', 'xss', 'platformUtils', 'loggingUtils', 'imageClientApi', 'swfobject', 'santaProps', 'displayer', 'wixUrlParser', 'mousetrap', 'DrawSVGPlugin', 'reactDOM', 'ScrollToPlugin', 'widgets', 'experiment', 'render', 'reactDOMServer', 'imageCommon', 'formCommon', 'textCommon', 'containerCommon', 'socialCommon', 'galleriesCommon', 'buttonCommon', 'compDesignUtils', 'mediaCommon', 'audioCommon', 'bluebird', 'skinExports', 'compUtils',
	      // Components
	      'fileUploader', 'wixSkinOnly', 'pinItPinWidget', 'siteButton', 'popupCloseTextButton', 'image', 'zoomedImage', 'wPhoto', 'clipArt', 'displayer', 'matrixGallery', 'wRichText', 'paginatedGridGallery', 'container', 'radioButton', 'radioGroup', 'headerContainer', 'footerContainer', 'screenWidthContainer', 'documentMedia', 'adminLoginButton', 'backgroundCommon', 'balata', 'datePicker', 'contactForm', 'subscribeForm', 'textArea', 'video', 'loginButton', 'googleMap', 'mediaContainerFactory', 'soundCloudWidget', 'paypalButton', 'imageButton', 'linkBar', 'comboBoxInput', 'spotifyPlayer', 'spotifyFollow', 'twitterFeed', 'backToTopButton', 'svgShape', 'facebookLike', 'facebookComments', 'facebookLikeBox', 'rssButton', 'textInput', 'tinyMenu', 'groupContainer', 'pinterestPinIt', 'pinterestFollow', 'wTwitterFollow', 'audioPlayer', 'column', 'htmlComponent', 'deadComponent'];
	      addConditionalDependencies(clientSidePackages);
	      return clientSidePackages;
	    }
	
	    function notifyParent(msg) {
	      try {
	        //eslint-disable-line no-empty
	        window.parent.postMessage(msg, '*');
	      } catch (e) {//eslint-disable-line no-empty
	      }
	    }
	
	    function renderClientSide(privates) {
	      var clientSidePackages = getClientSidePackages();
	      var wixCodeInitPkg = ['wixCodeInit'];
	      requirejs(wixCodeInitPkg, function (wixCodeInit) {
	        var wixCodeAppApi = wixCodeInit.getAppApi();
	
	        load(clientSidePackages, function (loadedPackages, ajaxHandler) {
	          if (privates) {
	            loadedPackages.render.clientSideWithPrivates(loadedPackages, privates, {
	              wixCodeAppApi: wixCodeAppApi
	            }, notifyParent.bind(null, 'santaReady'));
	          } else {
	            loadedPackages.render.clientSide(loadedPackages, ajaxHandler, siteModel, {
	              wixCodeAppApi: wixCodeAppApi
	            }, notifyParent.bind(null, 'santaReady'));
	          }
	        });
	
	        wixCodeInit.initMainR(wixCodeAppApi, siteModel, mobileView, queryUtil);
	      }, handleRequireError(wixCodeInitPkg));
	
	      loadAdditional(clientSidePackages);
	
	      (0, _miniPackages2.default)(window, requirejs, isServerSide);
	    }
	
	    function renderServerSide() {
	      load(['lodash', 'zepto', 'bluebird', 'coreUtils', 'loggingUtils', 'siteUtils', 'experiment', 'imageClientApi', 'skinExports', 'wixUrlParser', 'layout', 'warmup'], function (loadedPackages) {
	        loadedPackages.warmup.init(siteModel, function (privates) {
	          notifyParent('santaDidLayout');
	          renderClientSide(privates);
	        });
	      });
	    }
	
	    // Server side render state
	    window.sssr = {};
	
	    function callRender() {
	      if (isServerSide) {
	        renderServerSide();
	      } else {
	        renderClientSide();
	      }
	    }
	
	    if ((0, _isLocal2.default)(window.santaBase) && queryUtil.getParameterByName('hot') !== 'false') {
	      requirejs(['hot', 'zepto'], function (hot, $) {
	        hot.init($);
	        callRender();
	      });
	    } else {
	      callRender();
	    }
	  }
	
	  return render;
	};
	
	var _isLocal = __webpack_require__(7);
	
	var _isLocal2 = _interopRequireDefault(_isLocal);
	
	var _miniPackages = __webpack_require__(8);
	
	var _miniPackages2 = _interopRequireDefault(_miniPackages);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLocal;
	function isLocal(path) {
	  return (/^(https?:)?\/\/localhost($|[/:])/.test(path)
	  );
	}

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = miniPackages;
	/* eslint prefer-template:0 */
	
	function miniPackages(window, requirejs, isServerSide) {
	  var _window$location = window.location;
	  _window$location = _window$location === undefined ? {} : _window$location;
	  var hostname = _window$location.hostname;
	
	  // Prefetch font CSS files
	  // By marking them as media="none" their download is made non-blocking
	  // (At least for WebKit / Blink browsers)
	  // (WixThemeReact may remove this attribute)
	
	  if (!isServerSide && hostname !== 'localhost') {
	    requirejs(['lodash', 'fonts'], function (_, fonts) {
	      function enableLink() {
	        this.removeAttribute('media');
	      }
	
	      var document = window.document,
	          documentType = window.rendererModel.siteInfo.documentType,
	          serviceTopology = window.serviceTopology;
	
	      var cssUrls = fonts.fontUtils.getCssUrls(documentType, serviceTopology);
	      _.forEach(cssUrls, function (url, id) {
	        var link = document.createElement('link');
	        link.setAttribute('rel', 'stylesheet');
	        link.setAttribute('href', url);
	        link.setAttribute('media', 'none');
	        link.setAttribute('id', 'font_' + id);
	        link.addEventListener('load', enableLink, false);
	        document.head.appendChild(link);
	      });
	    });
	  }
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = addExperimentsFromQuery;
	/* eslint prefer-template:0 */
	
	function addExperimentsFromQuery(runningExperiments, queryUtil, project) {
	  var projValuePairRegex = new RegExp('^(' + project + ':)(.*)|(.*)$');
	
	  var experiments = {};
	  Object.keys(runningExperiments).forEach(function (key) {
	    experiments[key] = runningExperiments[key];
	  });
	
	  var setPair = function setPair(_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];
	
	    experiments[key] = value;
	  };
	  var getValueIfProj = function getValueIfProj(str) {
	    return str.replace(projValuePairRegex, '$2');
	  };
	
	  var filterParamsForCurrProj = function filterParamsForCurrProj(paramValue) {
	    return paramValue.split(';').map(getValueIfProj).filter(Boolean).join(',');
	  };
	
	  var setParamValues = function setParamValues(param, value) {
	    var paramValue = queryUtil.getParameterByName(param);
	    if (paramValue.indexOf(':') !== -1) {
	      // Should be deprecated
	      paramValue = filterParamsForCurrProj(paramValue);
	    }
	    paramValue.split(',').filter(Boolean).map(function (exp) {
	      return [exp, value];
	    }).forEach(setPair);
	  };
	
	  var setProjParamExperiments = function setProjParamExperiments() {
	    queryUtil.getParameterByName(project + 'exp').split(',').filter(Boolean).map(function (exp) {
	      return exp.split(':');
	    }).map(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          key = _ref4[0],
	          value = _ref4[1];
	
	      return [key.toLowerCase(), value || 'new'];
	    }).forEach(setPair);
	  };
	
	  //////////////////
	
	  setParamValues('experiments', 'new');
	  setParamValues('experimentsoff', 'old');
	  setProjParamExperiments();
	
	  return experiments;
	}

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = applyPackagesCache;
	function applyPackagesCache(_ref) {
	  var proj = _ref.proj,
	      paths = _ref.paths,
	      manifest = _ref.manifest,
	      version = _ref.version,
	      scriptsDomainUrl = _ref.scriptsDomainUrl;
	
	  var validForCache = function validForCache(pkg) {
	    return paths[pkg] && manifest[pkg] !== version;
	  };
	  var overrideFromCache = function overrideFromCache(pkg) {
	    paths[pkg] = scriptsDomainUrl + "services/" + proj + "/" + manifest[pkg] + "/" + paths[pkg];
	  };
	
	  Object.keys(manifest).filter(validForCache).forEach(overrideFromCache);
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFullRjsConfig;
	
	var _joinURL = __webpack_require__(12);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAddress = function isAddress(str) {
	  return (/^(https?:)?\/\//.test(str)
	  );
	}; /* eslint curly:0 */
	
	function getFullRjsConfig(name, base, config, packagesUtil, serviceTopology) {
	  function getBaseUrl() {
	    if (!base) return serviceTopology.scriptsLocationMap[name];
	    if (isAddress(base)) return base;
	    return (0, _joinURL2.default)(serviceTopology.scriptsDomainUrl, 'services', name, base);
	  }
	
	  config = packagesUtil.buildConfig(config);
	  config.baseUrl = getBaseUrl();
	  return config;
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint prefer-template:0 */
	
	module.exports = function joinURL() {
	  var url = arguments[0];
	  for (var i = 1; i < arguments.length; ++i) {
	    url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, '');
	  }
	  return url;
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQueryUtils;
	/* eslint prefer-template:0 */
	
	function getQueryUtils(window) {
	  /**
	   * Get value of URL parameter by its name
	   * @param {string} name
	   * @param {string} query
	   * @returns {string}
	   */
	  function getParameterFromQuery(query, name) {
	    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    var results = regex.exec(query);
	    return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : '';
	  }
	
	  /**
	   * Get state of boolean URL parameter by its name
	   * @param {string} name
	   * @param {string} query
	   * @returns {boolean}
	   */
	  function isParameterTrueInQuery(query, name) {
	    return getParameterFromQuery(query, name) === 'true';
	  }
	
	  return {
	    getParameterFromQuery: getParameterFromQuery,
	    isParameterTrueInQuery: isParameterTrueInQuery,
	    getParameterByName: getParameterFromQuery.bind(null, window.location.search),
	    isParameterTrue: isParameterTrueInQuery.bind(null, window.location.search)
	  };
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint prefer-template:0 */
	
	module.exports = function getSubdomain(domain) {
	  if (!domain) {
	    return '';
	  }
	  var subDomain = domain.split('.');
	  if (subDomain.length <= 2) {
	    subDomain = domain;
	  } else {
	    var beforeLastPart = subDomain[subDomain.length - 2];
	    var topLevelDomains = { com: true, org: true, net: true, edu: true, gov: true, mil: true, info: true, co: true, ac: true };
	    if (topLevelDomains[beforeLastPart]) {
	      subDomain = subDomain[subDomain.length - 3] + '.' + subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
	    } else {
	      subDomain = subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
	    }
	  }
	  return subDomain;
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window, requirejs, isSuspectedBot, prefetch) {
	  var _window$location = window.location,
	      location = _window$location === undefined ? {} : _window$location;
	  var _location$href = location.href,
	      href = _location$href === undefined ? '' : _location$href;
	
	
	  var delayedErrors = [];
	  function sendErrorOrQueue() {
	    var wixBiSession = window.wixBiSession;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (wixBiSession && wixBiSession.sendError) {
	      wixBiSession.sendError.apply(wixBiSession, args);
	    } else {
	      delayedErrors.push(args);
	    }
	  }
	
	  var _window$performance = window.performance,
	      performance = _window$performance === undefined ? {} : _window$performance;
	
	
	  function instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo) {
	    wixBiSession.initialTimestamp = wixBiSession.initialTimestamp || wixBiSession.mainLoaded;
	    wixBiSession.random = Math.random();
	
	    var sampleRatioState = queryUtil.getParameterByName('sampleratio');
	    var rendererModel = siteModel.rendererModel || window.rendererModel;
	    var premiumFeatures = rendererModel.premiumFeatures,
	        siteInfo = rendererModel.siteInfo;
	
	    var isPremium = !!premiumFeatures && premiumFeatures.indexOf('HasDomain') !== -1;
	    var base = (serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '');
	
	    function recordEt(et) {
	      wixBiSession.et = et;
	      if (performance.mark) {
	        performance.mark('beat ' + et);
	      }
	    }
	    wixBiSession.beat = recordEt;
	
	    var param = function param(name, value) {
	      return name + '=' + value;
	    };
	    var params = function params(pairs) {
	      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : param;
	      return Object.keys(pairs).map(function (value) {
	        return p(value, pairs[value]);
	      }).join('&');
	    };
	
	    var biBool = function biBool(bool) {
	      return Number(Boolean(bool));
	    };
	
	    function prepareMessage(evid, src, _ref) {
	      var _ref$omit = _ref.omit,
	          omit = _ref$omit === undefined ? {} : _ref$omit,
	          map = _ref.map,
	          _ref$pairs = _ref.pairs,
	          pairs = _ref$pairs === undefined ? {} : _ref$pairs;
	
	      pairs.evid = evid;
	      pairs.src = src;
	
	      if (!omit.pn) {
	        pairs.pn = 1;
	      }
	      if (!omit.isp) {
	        pairs.isp = biBool(isPremium);
	      }
	      if (!omit.url) {
	        var url = href.replace(/^[^:]+:\/\/(www\.)?/i, '');
	        pairs.url = encodeURIComponent(url.substring(0, 256));
	      }
	
	      if (!omit.v) {
	        pairs.v = siteModel.baseVersion || 'unknown';
	      }
	      if (!omit.majorVer) {
	        pairs.majorVer = window.clientSideRender ? 3 : 4;
	      }
	      if (!omit.ver && window.santaBase) {
	        var sourceMatches = window.santaBase.match(/([\d\.]+)\/?$/);
	        pairs.ver = sourceMatches && sourceMatches[1] || '';
	      }
	
	      if (!omit.dc && serviceTopology) {
	        var serverName = serviceTopology.serverName;
	        if (typeof serverName === 'string') {
	          var parts = serverName.split('.');
	          if (parts.length > 1) {
	            pairs.dc = parts[1];
	          }
	        }
	      }
	
	      if (siteInfo && siteInfo.siteId) {
	        pairs.sid = siteInfo.siteId;
	      }
	      if (rendererModel.metaSiteId) {
	        pairs.msid = rendererModel.metaSiteId;
	      }
	
	      var siteHeader = siteModel.siteHeader || window.siteHeader;
	      if (!omit.uuid && siteHeader && siteHeader.userId) {
	        pairs.uuid = siteHeader.userId;
	      }
	      var publicModel = siteModel.publicModel;
	
	      if (!omit.tsp && publicModel && publicModel.timeSincePublish) {
	        pairs.tsp = publicModel.timeSincePublish;
	      }
	      if (wixBiSession.viewerSessionId) {
	        pairs.vsi = wixBiSession.viewerSessionId;
	      }
	
	      if (!omit.ts && wixBiSession.initialTimestamp) {
	        pairs.ts = Date.now() - wixBiSession.initialTimestamp;
	      }
	
	      var _param = map ? function (name, value) {
	        return param(map[name] || name, value);
	      } : param;
	      return params(pairs, _param);
	    }
	
	    function sendBI(endpoint, evid, code) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      var src = base + '/' + endpoint + '?c=' + Date.now() + '&';
	      src += prepareMessage(evid, code, options);
	      if (options.extra) {
	        src += options.extra;
	      }
	      new window.Image().src = src;
	    }
	
	    wixBiSession.sendBI = function (endpoint, evid, code, extra, sampleRatio) {
	      if (!sampleRatio || Math.floor(wixBiSession.random * sampleRatio) === 0) {
	        sendBI(endpoint, evid, code, {
	          omit: {
	            pn: true,
	            isp: true,
	            ts: true,
	            url: true,
	            v: true,
	            ver: true
	          },
	          map: {
	            sid: 'did',
	            dc: 'server',
	            uuid: 'uid'
	          },
	          pairs: extra
	        });
	      }
	    };
	
	    var _sendError = function sendError(name, errc, sev) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        args[_key2 - 3] = arguments[_key2];
	      }
	
	      // eslint-disable-line func-style
	      _sendError = function sendError() {}; // only report one error per session
	
	      var pairs = {
	        errn: encodeURIComponent(name),
	        errc: errc,
	        sev: sev,
	        errscp: 'core',
	        cat: 2,
	        iss: 1,
	        et: wixBiSession.et
	      };
	
	      var total = 0;
	      pairs = args.reduce(function (result, arg, index) {
	        if (total + arg.length > 1024) {
	          arg = arg.substring(0, Math.max(1024 - total, 32));
	        }
	        result['p' + (index + 1)] = encodeURIComponent(arg);
	        total += result.length;
	        return result;
	      }, pairs);
	
	      sendBI('trg', 10, 44, {
	        omit: {
	          pn: true,
	          isp: true,
	          tsp: true,
	          v: true,
	          url: true,
	          uuid: true
	        },
	        map: {
	          sid: 'did',
	          dc: 'server',
	          ts: 'response_time'
	        },
	        pairs: pairs
	      });
	    };
	    wixBiSession.sendError = function (err) {
	      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }
	
	      return _sendError.apply(undefined, [err.errorName, err.errorCode, err.severity].concat(args));
	    };
	
	    delayedErrors.forEach(function (delayedError) {
	      return wixBiSession.sendError.apply(wixBiSession, _toConsumableArray(delayedError));
	    });
	    delayedErrors = null;
	
	    // Grow performance resource buffer as required
	    var isDebug = queryUtil.getParameterByName('debug');
	    if (performance.setResourceTimingBufferSize) {
	      if ('onresourcetimingbufferfull' in performance) {
	        performance.onresourcetimingbufferfull = function () {
	          var maxSize = 150;
	          return function () {
	            maxSize *= 2;
	            performance.setResourceTimingBufferSize(maxSize);
	          };
	        }();
	      } else {
	        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300);
	      }
	    }
	
	    var newrelic = window.newrelic;
	    if (newrelic) {
	      var shortUrl = href.replace(/^[^/]*\/\//, '');
	      if (newrelic.setPageViewName) {
	        newrelic.setPageViewName(shortUrl);
	      }
	      if (newrelic.setCustomAttribute) {
	        newrelic.setCustomAttribute('url', shortUrl);
	        if (siteInfo && siteInfo.siteId) {
	          newrelic.setCustomAttribute('sid', siteInfo.siteId);
	        }
	        if (rendererModel.metaSiteId) {
	          newrelic.setCustomAttribute('msid', rendererModel.metaSiteId);
	        }
	        var runningExperiments = rendererModel.runningExperiments;
	        if (runningExperiments) {
	          var runningExperimentKeys = Object.keys(runningExperiments).filter(function (key) {
	            return runningExperiments[key] !== 'old';
	          }).map(function (experimentName) {
	            var experimentValue = runningExperiments[experimentName];
	            return experimentValue !== 'new' ? experimentName + '=' + experimentValue : experimentName;
	          }).join('][');
	          if (runningExperimentKeys) {
	            newrelic.setCustomAttribute('experiments', '[' + runningExperimentKeys + ']');
	          }
	        }
	        newrelic.setCustomAttribute('preview', biBool(rendererModel.previewMode));
	        newrelic.setCustomAttribute('isPremium', isPremium);
	        var siteHeader = siteModel.siteHeader || window.siteHeader;
	        if (siteHeader && siteHeader.userId) {
	          newrelic.setCustomAttribute('uuid', siteHeader.userId);
	        }
	        var publicModel = siteModel.publicModel;
	        if (publicModel && publicModel.timeSincePublish) {
	          newrelic.setCustomAttribute('timeSincePublish', publicModel.timeSincePublish);
	        }
	        if (wixBiSession.viewerSessionId) {
	          newrelic.setCustomAttribute('vsi', wixBiSession.viewerSessionId);
	        }
	        newrelic.setCustomAttribute('debug', biBool(isDebug));
	      }
	    }
	
	    if (prefetch) {
	      wixBiSession.sendBI('ugc-viewer', 384, 42);
	      return;
	    }
	
	    if (!wixBiSession.viewerSessionId || rendererModel.previewMode || queryUtil.isParameterTrue('suppressbi')) {
	      return;
	    }
	
	    var isBot = /bot|google|phantom|crawler|spider|robot|crawling|^Mozilla\/4\.0$/i.test(window.navigator.userAgent);
	    if (siteInfo.documentType !== 'Template') {
	      (function validityBI() {
	        var isTop = void 0;
	        try {
	          isTop = window.self === window.top;
	        } catch (e) {
	          isTop = false;
	        }
	        if (!isSuspectedBot) {
	          try {
	            null[0]();
	          } catch (e) {
	            isSuspectedBot = /ph\x61n\x74om|n\x6fde/i.test(e.stack);
	          }
	        }
	        if (!isTop || isBot || isSuspectedBot) {
	          wixBiSession.sendBI('ugc-viewer', 361, 42, {
	            top: biBool(isTop),
	            bot: biBool(isBot),
	            sbot: biBool(isSuspectedBot)
	          });
	        }
	      })();
	    }
	
	    (function performanceBI() {
	      var pairs = {};
	      var navigation = performance.navigation,
	          timing = performance.timing;
	
	      if (timing) {
	        var domainLookupStart = timing.domainLookupStart,
	            domainLookupEnd = timing.domainLookupEnd,
	            redirectStart = timing.redirectStart,
	            redirectEnd = timing.redirectEnd,
	            connectStart = timing.connectStart,
	            connectEnd = timing.connectEnd,
	            secureConnectionStart = timing.secureConnectionStart,
	            requestStart = timing.requestStart,
	            responseStart = timing.responseStart,
	            responseEnd = timing.responseEnd;
	
	        var dnsTime = domainLookupEnd - domainLookupStart;
	        if (dnsTime >= 0) {
	          pairs.dns_time = dnsTime;
	        }
	        var redirectTime = redirectEnd - redirectStart;
	        if (redirectTime >= 0) {
	          pairs.redirect_time = redirectTime;
	        }
	        var connectTime = connectEnd - connectStart;
	        if (connectTime >= 0) {
	          pairs.connect_time = connectTime;
	        }
	        if (secureConnectionStart > 0) {
	          var sslTime = connectEnd - secureConnectionStart;
	          pairs.ssl_time = sslTime;
	        }
	        var ttfbTime = responseStart - requestStart;
	        if (ttfbTime >= 0) {
	          pairs.ttfb_time = ttfbTime;
	        }
	        var responseTime = responseEnd - responseStart;
	        if (responseTime >= 0) {
	          pairs.response_time = responseTime;
	        }
	        var loadTime = timing.navigationStart || timing.fetchStart || domainLookupStart || connectStart;
	        loadTime = wixBiSession.initialTimestamp - loadTime;
	        if (loadTime >= 0) {
	          pairs.load_time = loadTime;
	        }
	        if (pageInfo) {
	          pairs.page_id = pageInfo.pageId;
	        }
	        pairs.is_ssl = biBool(location.protocol === 'https:');
	      }
	      if (navigation) {
	        var redirectCount = navigation.redirectCount,
	            type = navigation.type;
	
	        if (type >= 0) {
	          pairs.navigation_type = type;
	        }
	        if (redirectCount >= 0) {
	          pairs.redirect_count = redirectCount;
	        }
	      }
	
	      pairs.is_premium = biBool(isPremium);
	      pairs.is_wixsite = biBool(siteInfo.documentType === 'WixSite');
	      pairs.is_ssr = biBool(!window.clientSideRender);
	
	      wixBiSession.sendBI('ugc-viewer', 351, 42, pairs);
	    })();
	
	    if (isDebug && sampleRatioState !== 'force') {
	      return;
	    }
	
	    var siteType = function () {
	      var BEAT_SITE_TYPES = ['No Site Type', 'WixSite', 'UGC', 'Template'];
	      var documentType = siteInfo.documentType;
	      var st = BEAT_SITE_TYPES.indexOf(documentType);
	      return st !== -1 ? st : documentType;
	    }();
	
	    wixBiSession.maybeBot = isBot || isSuspectedBot;
	    wixBiSession.beat = function (et, pid) {
	      recordEt(et);
	      var pairs = {
	        isjp: biBool(wixBiSession.maybeBot),
	        et: et,
	        st: siteType
	      };
	      if (pid) {
	        pairs.pid = pid;
	      }
	      sendBI('bt', 3, 29, {
	        omit: {
	          majorVer: true,
	          tsp: true,
	          ver: true
	        },
	        pairs: pairs
	      });
	    };
	
	    var ignoreURLs = [/^chrome(\-extension)?\:/, /^file\:/, /^resource\:/, /\.net\//, /\.info\//, /\.ru\//, /google/, /facebook/, /dropbox/, /ad\-score/, /drivemac/, /shopping/, /datafast/, /shopcomp/, /vimeo/, /olark/];
	    function ignoreError(where) {
	      where = where.trim();
	      if (!where) {
	        return true;
	      }
	      for (var i = 0; i < ignoreURLs.length; ++i) {
	        if (ignoreURLs[i].test(where)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    var onerror = window.onerror;
	
	    window.onerror = function (errorMsg, url, line, column, err) {
	      var where = err && typeof err.stack === 'string' ? err.stack : url;
	      if (!ignoreError(where)) {
	        _sendError('JAVASCRIPT_ERROR', 111022, 40, errorMsg, where, line, column); // JAVASCRIPT_ERROR from packages/core/src/main/bi/errors.js
	      }
	      if (onerror) {
	        return onerror.apply(this, arguments);
	      }
	    };
	
	    if (window.console) {
	      var _console = console,
	          error = _console.error;
	
	      if (error) {
	        console.error = function () {
	          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	          }
	
	          _sendError.apply(undefined, ['CONSOLE_ERROR', 111023, 30].concat(args)); // CONSOLE_ERROR from packages/core/src/main/bi/errors.js
	          return error.apply(this, arguments);
	        };
	      }
	    }
	
	    requirejs.onError = function (err) {
	      var modules = (err.requireModules || []).join(';');
	      var message = err.message,
	          stack = err.stack,
	          _err$errn = err.errn,
	          errn = _err$errn === undefined ? 'REQUIREJS_ERROR' : _err$errn,
	          _err$errc = err.errc,
	          errc = _err$errc === undefined ? 111024 : _err$errc,
	          _err$severity = err.severity,
	          severity = _err$severity === undefined ? 40 : _err$severity;
	
	      var where = stack ? '' + stack : '';
	      _sendError(errn, errc, severity, message, modules, where); // REQUIREJS_ERROR from packages/core/src/main/bi/errors.js
	    };
	  }
	
	  return {
	    sendErrorOrQueue: sendErrorOrQueue,
	    instrument: instrument
	  };
	};
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint prefer-template:0 */

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint prefer-template:0 */
	
	function isMobileDevice(window) {
	  var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	  var patternByDevice = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
	  var patternByModel = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i; // eslint-disable-line max-len
	  return patternByDevice.test(userAgent) || patternByModel.test(userAgent.substr(0, 4));
	}
	
	function isMobileView(window, siteModel, queryUtil) {
	  return queryUtil.isParameterTrue('showmobileview') || // eslint-disable-line no-extra-parens
	  isMobileDevice(window) && siteModel.rendererModel.siteMetaData && siteModel.rendererModel.siteMetaData.adaptiveMobileOn;
	}
	
	exports.default = { isMobileDevice: isMobileDevice, isMobileView: isMobileView };

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = overrideScriptsLocationMapFromQuery;
	
	var _replaceUrlVersion = __webpack_require__(18);
	
	var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
	  overrideParam.split(',').filter(Boolean).forEach(function (keyValueString) {
	    var pair = keyValueString.split(':');
	    var urlOverride = (0, _replaceUrlVersion2.default)(scriptsLocationMap[pair[0]], pair[1]);
	    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
	      scriptsLocationMap[pair[0]] = urlOverride;
	    }
	  });
	  return scriptsLocationMap;
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var bareSemver = /(\d)+\.(\d)+\.(\d)+/;
	var onlyBareSemver = /^(\d)+\.(\d)+\.(\d)+$/;
	var onlySha = /^[0-9a-f]{40}$/;
	
	var validVersion = function validVersion(version) {
	  return onlyBareSemver.test(version) || onlySha.test(version);
	};
	
	function replaceUrlVersion(url, version) {
	  return url && validVersion(version) ? url.replace(bareSemver, version) : url;
	}
	
	exports.default = replaceUrlVersion;

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = requirejs;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = resourcePrefetch;
	
	var _joinURL = __webpack_require__(12);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function resourcePrefetch(_ref, _ref2) {
	  var XMLHttpRequest = _ref.XMLHttpRequest,
	      santaBase = _ref.santaBase;
	  var siteModel = _ref2.siteModel,
	      publicModel = _ref2.publicModel,
	      pageInfo = _ref2.pageInfo,
	      shouldTimeout = _ref2.shouldTimeout,
	      wixBiSession = _ref2.wixBiSession,
	      dynamicModel = _ref2.dynamicModel,
	      isServerSide = _ref2.isServerSide;
	
	  var cache = {};
	  var pending = {};
	
	  function _prefetch(url, options, pageId) {
	    var r = new XMLHttpRequest();
	
	    r.onload = function () {
	      if (this.status >= 200 && this.status < 300) {
	        var cached = options.parse ? options.parse(r.response) : r.response;
	        cache[url] = cached;
	        pending[url].filter(function (op) {
	          return op.success;
	        }).forEach(function (op) {
	          op.success(cached);
	        });
	      } else {
	        this.onerror();
	      }
	    };
	    r.onerror = function () {
	      cache[url] = r;
	      pending[url].filter(function (op) {
	        return op.error;
	      }).forEach(function (op) {
	        op.error(r);
	      });
	    };
	    r.onloadend = function () {
	      delete pending[url];
	    };
	
	    r.open('GET', url, true);
	
	    //Property timeout MUST be after .open() and before .send()
	    //This is related to an issue with IE - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
	    if (shouldTimeout) {
	      r.timeout = 2000;
	      r.ontimeout = function () {
	        if (pageId) {
	          //beat 2 = 'reset' event
	          wixBiSession.beat(2, pageId);
	        }
	      };
	    }
	    //Property timeout MUST be after .open() and before .send()
	
	    if (options.accept) {
	      r.setRequestHeader('Accept', options.accept);
	    }
	
	    r.send();
	  }
	
	  function prefetch(url, options, pageId) {
	    if (url) {
	      options = options || {};
	      var cached = cache[url];
	      if (cached) {
	        if (options.success) {
	          options.success(cached);
	        }
	      } else {
	        var p = pending[url];
	        if (!p) {
	          pending[url] = p = [];
	          _prefetch(url, options, pageId);
	        }
	        p.push(options);
	      }
	    }
	  }
	
	  function prefetchJSON(url, pageId) {
	    prefetch(url, {
	      accept: 'application/json',
	      parse: function parse(response) {
	        var json = null;
	        try {
	          json = JSON.parse(response);
	          prefetchSvg(json.structure, response);
	          prefetchBlog(json);
	        } catch (e) {
	          // empty
	        }
	        return json;
	      }
	    }, pageId);
	  }
	
	  function prefetchBlog(json) {
	    var _siteModel$rendererMo = siteModel.rendererModel.clientSpecMap,
	        clientSpecMap = _siteModel$rendererMo === undefined ? {} : _siteModel$rendererMo;
	    var _json$structure = json.structure;
	    _json$structure = _json$structure === undefined ? {} : _json$structure;
	    var _json$structure$compo = _json$structure.components,
	        components = _json$structure$compo === undefined ? [] : _json$structure$compo;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var _step$value = _step.value,
	            type = _step$value.type,
	            componentType = _step$value.componentType,
	            _step$value$dataQuery = _step$value.dataQuery,
	            dataQuery = _step$value$dataQuery === undefined ? '' : _step$value$dataQuery;
	
	        if (type === 'Component' && componentType === 'wixapps.integration.components.AppPart') {
	          var _json$data = json.data;
	          _json$data = _json$data === undefined ? {} : _json$data;
	          var _json$data$document_d = _json$data.document_data,
	              document_data = _json$data$document_d === undefined ? {} : _json$data$document_d;
	
	          var dq = dataQuery[0] === '#' ? dataQuery.substring(1) : dataQuery;
	          var appInnerID = document_data[dq].appInnerID;
	          var _clientSpecMap$appInn = clientSpecMap[appInnerID],
	              tp = _clientSpecMap$appInn.type,
	              packageName = _clientSpecMap$appInn.packageName;
	
	          if (tp === 'wixapps' && packageName === 'blog' && !isServerSide) {
	            prefetchJSON((0, _joinURL2.default)(santaBase, 'static/wixapps/apps/blog/descriptor.json'));
	            return;
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  function shapeSkinNameToUrl(shapeSkinName) {
	    function getSvgUri(version, svgHash, shapeName) {
	      return svgHash + (version === 1 ? '_svgshape.v1.' + shapeName : '') + '.svg';
	    }
	
	    var mediaRootUrl = siteModel.serviceTopology.mediaRootUrl;
	    var partsArr = shapeSkinName.replace(/^.*\//, '').split('.');
	    var version = partsArr[1] === 'v1' ? 1 : 2;
	    var svgHash = partsArr[2].replace(/svg_/i, '');
	    var svgName = partsArr[3];
	    var svgUri = getSvgUri(version, svgHash, svgName);
	    return (0, _joinURL2.default)(mediaRootUrl, 'shapes', svgUri);
	  }
	
	  var svgMap = {
	    'skins.viewer.svgshape.SvgShapeDefaultSki': true
	  };
	  function prefetchSvg(structure, response) {
	    if (structure && response.indexOf('"svg') !== -1) {
	      var svgs = JSON.stringify(structure).match(/"skin"\s*:\s*"svg[^"]+"/g);
	      if (svgs) {
	        svgs.map(function (m) {
	          m = m.match(/svg[^"]+/);
	          return m && m[0];
	        }).filter(function (svg) {
	          if (!svg || svgMap[svg]) {
	            return false;
	          }
	          svgMap[svg] = true;
	          return true;
	        }).map(shapeSkinNameToUrl).forEach(function (url) {
	          prefetch(url);
	        });
	      }
	    }
	  }
	
	  function getFirstUrl(pageJsonFileName) {
	    if (pageJsonFileName) {
	      var topology = publicModel.pageList.topology[0];
	      return topology.baseUrl + topology.parts.replace('{filename}', pageJsonFileName);
	    }
	  }
	
	  function getMasterPageFirstURL() {
	    var _publicModel$pageList = publicModel.pageList,
	        masterPageJsonFileName = _publicModel$pageList.masterPageJsonFileName,
	        masterPage = _publicModel$pageList.masterPage;
	
	    return getFirstUrl(masterPageJsonFileName) || masterPage && masterPage[0];
	  }
	
	  function getPageFirstURL() {
	    return getFirstUrl(pageInfo.pageJsonFileName) || pageInfo.urls[0];
	  }
	
	  function hasPagesDataFromSSR() {
	    var pageDataCount = Object.keys(siteModel.pagesData || {}).length;
	    return isServerSide && pageDataCount > 0;
	  }
	
	  try {
	    prefetchJSON(dynamicModel);
	
	    if (!hasPagesDataFromSSR()) {
	      prefetchJSON(getMasterPageFirstURL(), 'masterPage');
	      if (pageInfo) {
	        prefetchJSON(getPageFirstURL(), pageInfo.pageId);
	      }
	    }
	  } catch (e) {
	    // empty
	  }
	
	  var cbs = [];
	  function async(cb) {
	    if (cbs.push(cb) === 1) {
	      setTimeout(function () {
	        var fs = cbs;
	        cbs = [];
	        fs.forEach(function (f) {
	          f();
	        });
	      }, 0);
	    }
	  }
	
	  return function (options) {
	    var url = options.url;
	    var cached = cache[url];
	    if (cached) {
	      async(function () {
	        if (cached instanceof XMLHttpRequest) {
	          options.error(cached);
	        } else {
	          options.success(cached);
	        }
	      });
	    } else if (pending[url]) {
	      pending[url].push(options);
	    } else {
	      return false;
	    }
	    return true;
	  };
	} /* eslint prefer-template:0 */
	/* eslint indent:0 */

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window, versions) {
	  function getViewerRjsConfig(serviceTopology) {
	    //TODO: cancel fallback to staticServerUrl when server is stable
	    var scriptsLocation = serviceTopology.scriptsDomainUrl;
	    var thirdParty = _joinURL2.default.bind(null, scriptsLocation, 'services', 'third-party');
	
	    var getIntegrationPath = function getIntegrationPath() {
	      //eslint-disable-line func-style
	      return (0, _isLocal2.default)(window.santaBase) ? '//localhost:4578' : '//s3.amazonaws.com/integration-tests-statics/SNAPSHOT/runners';
	    };
	
	    return {
	      //By default load any module IDs from js/lib
	      baseUrl: '/',
	      //except, if the module ID starts with "app",
	      //load it from the js/app directory. paths
	      //config is relative to the baseUrl, and
	      //never includes a ".js" extension since
	      //the paths config could be for a directory.
	      paths: {
	        experiment: 'js/plugins/experiment/experiment',
	        platformUtils: './node_modules/santa-platform-utils/dist/platformUtils-bundle',
	        coreUtilsLib: 'node_modules/santa-core-utils/dist/coreUtils',
	        imageClientLib: 'node_modules/santa-core-utils/dist/imageClientApi',
	        wixImmutable: 'node_modules/santa-core-utils/dist/wixImmutable',
	        lodash: thirdParty('lodash/' + versions.lodash + '/lodash.min'),
	        react: { min: thirdParty('react/' + versions.react + '/react-with-addons.min'), source: '//cdnjs.cloudflare.com/ajax/libs/react/' + versions.react + '/react-with-addons' },
	        reactDOM: { min: thirdParty('react/' + versions.react + '/react-dom.min'), source: '//cdnjs.cloudflare.com/ajax/libs/react/' + versions.react + '/react-dom' },
	        reactDOMServer: { min: thirdParty('react/' + versions.react + '/react-dom-server.min'), source: '//cdnjs.cloudflare.com/ajax/libs/react/' + versions.react + '/react-dom-server' },
	        zepto: { min: thirdParty('zepto/1.2.0/zepto.min'), source: thirdParty('zepto/1.2.0/zepto') },
	        speakingurl: thirdParty('speakingurl/speakingurl.min'),
	        immutable: {
	          min: thirdParty('immutable/3.7.5/dist/immutable.min'),
	          source: thirdParty('immutable/3.7.5/dist/immutable')
	        },
	        mousetrap: thirdParty('mousetrap/1.4.6/mousetrap.min'),
	        swfobject: thirdParty('swfobject/2.3.20130521/swfobject.min'),
	        TweenMax: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        TweenLite: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        TimelineMax: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        ScrollToPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/ScrollToPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/ScrollToPlugin') },
	        DrawSVGPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/DrawSVGPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/DrawSVGPlugin') },
	        MorphSVGPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/MorphSVGPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/MorphSVGPlugin') },
	        Draggable: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/utils/Draggable.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/utils/Draggable') },
	        color: thirdParty('color-convert/0.2.0/color.min'),
	        hammer: thirdParty('hammerjs/2.0.8/hammer.min'),
	        jasmine: thirdParty('jasmine/2.1.3/jasmine'),
	        'jasmine-html': thirdParty('jasmine/2.1.3/jasmine-html'),
	        'jasmine-boot': thirdParty('jasmine/2.1.3/jasmine-boot'),
	        bluebird: { min: thirdParty('bluebird/2.9.4/bluebird.min'), source: thirdParty('bluebird/2.9.4/bluebird') },
	        SoundManager: thirdParty('soundmanager2/V2.97a.20150601/soundmanager2-nodebug-jsmin'),
	        'date-fns': { min: thirdParty('date-fns/v1.3.0/date_fns.min'), source: thirdParty('date-fns/v1.3.0/date_fns') },
	        ajv: { min: thirdParty('ajv/4.8.1/ajv.min'), source: thirdParty('ajv/4.8.1/ajv.bundle') },
	        ReactProxy: 'js/vendor/ReactProxy',
	        Squire: 'js/vendor/squire/Squire',
	        io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
	        hot: './node_modules/santa-utils/common/hot/listener',
	        'wix-fullstory-loader': './node_modules/wix-fullstory-loader/dist/statics/app.bundle',
	        patcher: './node_modules/santa-utils/common/hot/patcher',
	        fake: 'js/plugins/fake/src/main/fake',
	        definition: 'js/plugins/definition/src/main/definition',
	        jsonpatch: 'js/vendor/json-patch/json-patch.umd',
	        xss: { min: thirdParty('xss/0.2.12/xss.min'), source: thirdParty('xss/0.2.12/xss') },
	        immutableDiff: 'js/vendor/immutablejsdiff.min',
	        pmrpc: (0, _joinURL2.default)(scriptsLocation, 'services/pm-rpc/' + versions.pmrpc + '/lib/pm-rpc.min'),
	        'ag-grid': { min: thirdParty('ag-grid/6.2.1/dist/ag-grid.min'), source: thirdParty('ag-grid/6.2.1/dist/ag-grid') },
	        mobx: { min: 'js/vendor/mobx/' + versions.mobx + '/mobx.umd.min', source: 'js/vendor/mobx/' + versions.mobx + '/mobx.umd' },
	        'mobx-react': { min: 'js/vendor/mobx/' + versions.mobxReact + '/mobx-react.min', source: 'js/vendor/mobx/' + versions.mobxReact + '/mobx-react' }
	      },
	      map: {
	        'mobx-react': {
	          'react-dom': 'reactDOM'
	        }
	      },
	      // generated
	      packages: [{
	        name: 'tpaIntegration',
	        main: 'tpaIntegration',
	        location: getIntegrationPath() + '/tpaIntegration/src/main'
	      }, {
	        name: 'wixCodeIntegration',
	        main: 'wixCodeIntegration',
	        location: getIntegrationPath() + '/wixCodeIntegration/src/main'
	      }],
	      bundles: null,
	      shim: {
	        zepto: { exports: '$' },
	        color: { exports: 'Color' },
	        'jasmine-html': {
	          deps: ['jasmine']
	        },
	        'jasmine-boot': {
	          deps: ['jasmine', 'jasmine-html']
	        },
	        bluebird: { exports: 'bluebird' },
	        SoundManager: { exports: 'soundManager' },
	        ReactProxy: {
	          deps: ['react'],
	          exports: 'ReactProxy'
	        },
	        jsonpatch: { exports: 'jsonpatch' },
	        xss: { exports: 'filterXSS' }
	      },
	      waitSeconds: 0
	    };
	  }
	  return getViewerRjsConfig;
	};
	
	var _isLocal = __webpack_require__(7);
	
	var _isLocal2 = _interopRequireDefault(_isLocal);
	
	var _joinURL = __webpack_require__(12);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window) {
	  function isAvailable(name) {
	    try {
	      var unique = 'testStorage' + Date.now();
	      var st = window[name];
	      st.setItem(unique, unique);
	      var value = st.getItem(unique);
	      st.removeItem(unique);
	      if (value !== unique) {
	        throw 'not equal'; //eslint-disable-line no-throw-literal
	      }
	    } catch (e) {
	      return false;
	    }
	    return true;
	  }
	
	  var storage = void 0;
	  if (isAvailable('localStorage')) {
	    storage = window.localStorage;
	  } else if (isAvailable('sessionStorage')) {
	    storage = window.sessionStorage;
	  } else {
	    storage = {
	      setItem: function setItem() {},
	      getItem: function getItem() {},
	      removeItem: function removeItem() {}
	    };
	  }
	
	  return {
	    save: function save(key, value) {
	      storage.setItem(key, value);
	    },
	    load: function load(key) {
	      return storage.getItem(key);
	    },
	    remove: function remove(key) {
	      storage.removeItem(key);
	    }
	  };
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint prefer-template:0 */
	
	function initExperimentTest(experiments) {
	  var fixed = Object.keys(experiments || {}).reduce(function (accu, key) {
	    if (experiments[key] === 'new') {
	      accu[key.toLowerCase()] = true;
	    }
	    return accu;
	  }, {});
	
	  return function (name) {
	    return fixed[name.toLowerCase()];
	  };
	}
	
	function getPageInfo(window, pageList) {
	  if (!pageList) {
	    return null;
	  }
	  var pages = pageList.pages || [];
	
	  function getPageById(pageId) {
	    for (var i = 0; i < pages.length; ++i) {
	      if (pages[i].pageId === pageId) {
	        return pages[i];
	      }
	    }
	  }
	
	  var hash = window.location.hash.split('/');
	  var pageId = hash[1];
	  if (pageId) {
	    var page = getPageById(pageId);
	    if (page) {
	      return page;
	    }
	  }
	
	  var pathname = window.location.pathname;
	  if (pathname) {
	    for (var i = 0; i < pages.length; ++i) {
	      var pageUriSEO = pages[i].pageUriSEO;
	      if (pageUriSEO) {
	        var re = new RegExp('(^|/)' + pageUriSEO + '(/|$)');
	        if (re.test(pathname)) {
	          return pages[i];
	        }
	      }
	    }
	  }
	
	  return pageList.mainPageId && getPageById(pageList.mainPageId);
	}
	
	exports.default = { initExperimentTest: initExperimentTest, getPageInfo: getPageInfo };

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = {
		"version": "1.2207.8",
		"manifest": {
			"adminLoginButton": "1.2200.2",
			"animations": "1.2186.4",
			"audioCommon": "1.2160.7",
			"audioPlayer": "1.2080.9",
			"backToTopButton": "1.2177.3",
			"backgroundCommon": "1.2200.2",
			"balata": "1.2207.8",
			"bgImageStrip": "1.2108.3",
			"boxSlideShowSlide": "1.2144.4",
			"buttonCommon": "1.2080.9",
			"checkbox": "1.2200.2",
			"clipArt": "1.2200.2",
			"column": "1.2108.3",
			"comboBoxInput": "1.2108.3",
			"compDesignUtils": "1.2080.9",
			"compUtils": "1.2186.4",
			"components": "1.2207.8",
			"componentsPreviewLayer": "1.2186.5",
			"contactForm": "1.2080.9",
			"container": "1.2010.8",
			"containerCommon": "1.2010.8",
			"core": "1.2207.8",
			"coreUtils": "1.2207.8",
			"dataFixer": "1.2207.8",
			"datePicker": "1.2186.4",
			"dateUtils": "1.2010.8",
			"deadComponent": "1.2040.17",
			"displayer": "1.2177.3",
			"documentMedia": "1.2080.9",
			"documentServices": "1.2207.8",
			"dropDownMenu": "1.2186.4",
			"editingRendererPlugins": "1.2010.8",
			"exitMobileModeButton": "1.2080.9",
			"facebookComments": "1.2160.7",
			"facebookLike": "1.2186.4",
			"facebookLikeBox": "1.2010.8",
			"facebookShare": "1.2108.3",
			"fileUploader": "1.2160.7",
			"flashComponent": "1.2108.3",
			"flickrBadgeWidget": "1.2186.4",
			"fonts": "1.2177.3",
			"fontsPrefetch": "1.2010.8",
			"footerContainer": "1.2010.8",
			"formCommon": "1.2144.4",
			"galleriesCommon": "1.2108.3",
			"googleMap": "1.2080.9",
			"groupContainer": "1.2040.17",
			"headerContainer": "1.2010.8",
			"hoverBox": "1.2108.3",
			"htmlComponent": "1.2177.3",
			"image": "1.2186.4",
			"imageButton": "1.2040.17",
			"imageClientApi": "1.2177.3",
			"imageCommon": "1.2108.3",
			"imageZoom": "1.2177.3",
			"imageZoomDisplayer": "1.2177.3",
			"infoTip": "1.2200.2",
			"itunesButton": "1.2108.3",
			"layout": "1.2207.8",
			"linkBar": "1.2080.9",
			"loggingUtils": "1.2200.2",
			"loginButton": "1.2108.3",
			"matrixGallery": "1.2177.3",
			"mediaCommon": "1.2207.8",
			"mediaContainerFactory": "1.2144.4",
			"mediaControls": "1.2207.8",
			"mediaPlayer": "1.2200.2",
			"mediaZoom": "1.2177.3",
			"menuButton": "1.2186.4",
			"messageView": "1.2149.2",
			"mobileActionsMenu": "1.2177.3",
			"multilingual": "1.2207.8",
			"page": "1.2144.4",
			"paginatedGridGallery": "1.2186.4",
			"paypalButton": "1.2010.8",
			"pinItPinWidget": "1.2144.4",
			"pinterestFollow": "1.2080.9",
			"pinterestPinIt": "1.2186.4",
			"popupCloseTextButton": "1.2108.3",
			"popupContainer": "1.2144.4",
			"previewExtensionsCore": "1.2144.4",
			"qaAutomation": "1.2080.9",
			"quickActionBar": "1.2186.4",
			"radioButton": "1.2207.8",
			"radioGroup": "1.2207.8",
			"render": "1.2207.8",
			"rssButton": "1.2010.8",
			"santaPreview": "1.2186.4",
			"santaProps": "1.2207.8",
			"screenWidthContainer": "1.2010.8",
			"server": "1.2177.3",
			"singleAudioPlayer": "1.2080.9",
			"siteBackground": "1.2186.4",
			"siteButton": "1.2080.9",
			"siteUtils": "1.2207.8",
			"skinExports": "1.2200.2",
			"skins": "1.2207.8",
			"skypeCallButton": "1.2108.3",
			"slideShowGallery": "1.2200.2",
			"sliderGallery": "1.2200.2",
			"socialCommon": "1.2177.3",
			"soundCloudWidget": "1.2177.3",
			"spotifyFollow": "1.2186.4",
			"spotifyPlayer": "1.2177.3",
			"stripColumnsContainer": "1.2144.4",
			"stripContainer": "1.2144.4",
			"stripSlideShow": "1.2207.8",
			"stripSlideShowSlide": "1.2144.4",
			"subscribeForm": "1.2080.9",
			"svgCommon": "1.2207.8",
			"svgShape": "1.2207.8",
			"testUtils": "1.2207.8",
			"textArea": "1.2177.3",
			"textCommon": "1.2200.2",
			"textInput": "1.2010.8",
			"tinyMenu": "1.2207.8",
			"tpa": "1.2207.8",
			"tpaGalleries": "1.2207.8",
			"translationsUtils": "1.2128.6",
			"tweenEngine": "1.2160.7",
			"twitterFeed": "1.2010.8",
			"utils": "1.2200.2",
			"vKShareButton": "1.2186.4",
			"verticalAnchorsMenu": "1.2200.2",
			"verticalMenu": "1.2177.3",
			"video": "1.2160.7",
			"wGooglePlusOne": "1.2177.3",
			"wPhoto": "1.2160.7",
			"wRichText": "1.2080.9",
			"wTwitterFollow": "1.2010.8",
			"wTwitterTweet": "1.2177.3",
			"warmup": "1.2200.2",
			"widgets": "1.2207.8",
			"wixCode": "1.2207.8",
			"wixCodeInit": "1.2177.3",
			"wixCodeSeo": "1.2200.2",
			"wixSites": "1.2200.2",
			"wixSkinOnly": "1.2010.8",
			"wixUrlParser": "1.2144.4",
			"wixads": "1.2177.3",
			"wixappsBuilder": "1.2177.3",
			"wixappsClassics": "1.2207.8",
			"wixappsCore": "1.2200.2",
			"youTubeSubscribeButton": "1.2186.4",
			"zoomedImage": "1.2010.8"
		},
		"versions": {
			"mobx": "3.1.0",
			"mobxReact": "3.5.8",
			"lodash": "4.17.4/dist",
			"react": "0.14.3",
			"tweenmax": "1.19.0",
			"pmrpc": "1.30.0"
		},
		"packages": [
			"adminLoginButton",
			"animations",
			"audioCommon",
			"audioPlayer",
			"backToTopButton",
			"backgroundCommon",
			"balata",
			"bgImageStrip",
			"boxSlideShowSlide",
			"buttonCommon",
			"checkbox",
			"clipArt",
			"column",
			"comboBoxInput",
			"compDesignUtils",
			"compUtils",
			"components",
			"componentsPreviewLayer",
			"contactForm",
			"container",
			"containerCommon",
			"core",
			"coreUtils",
			"dataFixer",
			"datePicker",
			"dateUtils",
			"deadComponent",
			"displayer",
			"documentMedia",
			"documentServices",
			"dropDownMenu",
			"editingRendererPlugins",
			"exitMobileModeButton",
			"facebookComments",
			"facebookLike",
			"facebookLikeBox",
			"facebookShare",
			"fileUploader",
			"flashComponent",
			"flickrBadgeWidget",
			"fonts",
			"fontsPrefetch",
			"footerContainer",
			"formCommon",
			"galleriesCommon",
			"googleMap",
			"groupContainer",
			"headerContainer",
			"hoverBox",
			"htmlComponent",
			"image",
			"imageButton",
			"imageClientApi",
			"imageCommon",
			"imageZoom",
			"imageZoomDisplayer",
			"infoTip",
			"itunesButton",
			"layout",
			"linkBar",
			"loggingUtils",
			"loginButton",
			"matrixGallery",
			"mediaCommon",
			"mediaContainerFactory",
			"mediaControls",
			"mediaPlayer",
			"mediaZoom",
			"menuButton",
			"messageView",
			"mobileActionsMenu",
			"multilingual",
			"page",
			"paginatedGridGallery",
			"paypalButton",
			"pinItPinWidget",
			"pinterestFollow",
			"pinterestPinIt",
			"popupCloseTextButton",
			"popupContainer",
			"previewExtensionsCore",
			"qaAutomation",
			"quickActionBar",
			"radioButton",
			"radioGroup",
			"render",
			"rssButton",
			"santaPreview",
			"santaProps",
			"screenWidthContainer",
			"server",
			"singleAudioPlayer",
			"siteBackground",
			"siteButton",
			"siteUtils",
			"skinExports",
			"skins",
			"skypeCallButton",
			"slideShowGallery",
			"sliderGallery",
			"socialCommon",
			"soundCloudWidget",
			"spotifyFollow",
			"spotifyPlayer",
			"stripColumnsContainer",
			"stripContainer",
			"stripSlideShow",
			"stripSlideShowSlide",
			"subscribeForm",
			"svgCommon",
			"svgShape",
			"testUtils",
			"textArea",
			"textCommon",
			"textInput",
			"tinyMenu",
			"tpa",
			"tpaGalleries",
			"translationsUtils",
			"tweenEngine",
			"twitterFeed",
			"utils",
			"vKShareButton",
			"verticalAnchorsMenu",
			"verticalMenu",
			"video",
			"wGooglePlusOne",
			"wPhoto",
			"wRichText",
			"wTwitterFollow",
			"wTwitterTweet",
			"warmup",
			"widgets",
			"wixCode",
			"wixCodeInit",
			"wixCodeSeo",
			"wixSites",
			"wixSkinOnly",
			"wixUrlParser",
			"wixads",
			"wixappsBuilder",
			"wixappsClassics",
			"wixappsCore",
			"youTubeSubscribeButton",
			"zoomedImage"
		]
	};

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// main-r.min.js